// REACT
import * as React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from '../actions';

// COMPONENTS
import VideoUI from '../components/VideoUI/VideoUI';
import LoginStartConsult from '../components/Dialog/LoginStartConsult';
import FlexColumn from '../components/Primatives/FlexColumn';
import Button from '../components/Primatives/Button';
import H2 from '../components/Primatives/H2';

// VENDOR COMPONENTS
import { preloadScript } from 'opentok-react';
import { Redirect, withRouter } from 'react-router-dom';
const moment = require('moment-timezone');
import isEqual from 'lodash/isEqual';

// UTILS
import { constants } from '../constants/index';

//RENDER PROPS
import ScreenDimensionProvider from '../../ScreenDimensionProvider';

class Consultations extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            joinSession: null,
            loginDialogOpen: false,
            sessionDataReceived: false,
            didGetMessageThread: false,
            facingMode: 'user',
            shouldRefreshSession: false,
        };
    }

    componentDidMount() {
        document.getElementById('top').scrollIntoView();
        let hash = this.props.match.params.id.slice(0, -8);
        // console.log('HASH', hash);
        const { userData, getSessionData, userId, match, selectedClient } = this.props;

        this.props.getConsultServiceData(hash);
        const selectedService = this.props.consultService;
        // { selectedService && selectedService._id &&
        //     this.getUnreadCount(selectedService);
        // }
        if (this.props.userData && this.props.userData.provider) {
            this.props.filterClientProfileByActivityStatus(this.props.userData);
        }
        // console.log('this.props.userId, this.props.selectedClient.uid, selectedService._id', this.props.userId, this.props.selectedClient && this.props.selectedClient.uid, selectedService && selectedService._id)
        // console.log('selectedService-s', selectedService)
        // console.log('selectedService-this.props.consultService', this.props.consultService)

        this.props.getDBProviders();
        this.props.getDBServices();
        this.props.getDBProviderCompanies();
        this.props.getDBServiceCategories();
        this.props.getDBServiceModules();
        // console.log('getMessageThread userData', userData)
        // console.log('getMessageThread selectedService', selectedService)
        // console.log('props@consultationsDidMount', this.props)
        // console.log('CDM props userdata',this.props.userData)
        // console.log('cosult-userData.uid', userData && userData.uid,)
        // console.log('cosult-selectedService.provider', selectedService && selectedService.provider)
        // console.log('cosult-selectedService._id', selectedService && selectedService._id,)

        this.props.loadUpcomingDbBookings({
            userId: userData && userData.uid,
            serviceId: selectedService && selectedService._id,
            // clientUid,
            userType: 'client',
        });

        this.getProviderCompanyService(this.props);

        if (userId && match && match.params && match.params.id && userData && userData.uid) {
            // GET SESSION DATA FOR VIDEO CONSULTE NEEDS TO BE CALLED EVERY TIME THE COMPONENT MOUNTS EVEN IF WE HAVE SESSION DATA.
            // THIS IS TO ENSURE THAT WE HAVE THE RIGHT SESSION DATA FOR THE CONSULTATION
            getSessionData(match.params.id, userId, userData.provider ? 'provider' : 'client');
        }
    }

    componentWillReceiveProps(nextProps) {
        const bookingHashId = this.props.match.params.id.slice(0, -8);
        const selectedService = nextProps.consultService;
        const isUserDataLoaded = nextProps.userData && nextProps.userData.uid;
        const isProvider = isUserDataLoaded && nextProps.userData.provider;

        if (!nextProps.otherVideoUser && isUserDataLoaded) {
            this.props.getOtherUsersDataByUserType({
                hash: bookingHashId,
                isProvider,
            });
        }

        if (!(this.state.company && this.state.provider && this.state.service)) {
            this.getProviderCompanyService(nextProps);
        }

        if (!this.state.didGetMessageThread && isUserDataLoaded) {
            if (!isProvider) {
                this.props.getMessageThread(nextProps.userData, selectedService, threadKey => {
                    // console.log('GOT CHANNEL @ HANDLE SERVICE SELECT', threadKey);
                    this.setState({ didGetMessageThread: true });
                });
            }

            if (isProvider && nextProps.otherVideoUser) {
                this.props.getMessageThread(
                    nextProps.userData,
                    selectedService,
                    () => {
                        console.log('GOT MESSAGE THREAD AT PRO SERVICE SELECT');
                    },
                    'provider',
                    nextProps.otherVideoUser,
                );
                this.setState({ didGetMessageThread: true });

                this.props.setSelectedClient(nextProps.otherVideoUser);
            }
        }
    }

    handleOpenLoginDialog = joinSession => {
        if (!this.props.userId) {
            this.setState({
                joinSession: joinSession,
                loginDialogOpen: true,
            });
        } else {
            joinSession();
        }
    };

    handleCloseLoginDialog = () => {
        this.setState({
            loginDialogOpen: false,
        });
    };

    handleStartConsult = () => {
        this.setState({
            joinSession: true,
        });
    };

    // cameraToggle needs to call set state in the same component as CDM getSessionData to ensure that sessionDate is called again when re-entering the video session
    cameraToggle = () => {
        if (this.state.facingMode === 'user') {
            this.setState(
                {
                    facingMode: 'environment',
                    shouldRefreshSession: true,
                },
                () => {
                    this.setState({
                        shouldRefreshSession: false,
                    });
                },
            );
        } else {
            this.setState(
                {
                    facingMode: 'user',
                    shouldRefreshSession: true,
                },
                () => {
                    this.setState({
                        shouldRefreshSession: false,
                    });
                },
            );
        }
    };

    handleRefreshSessionData = () => {
        // CALLING SET STATE TRIGGERS GET SESSION DATA FUNCTION IN CDM
        this.setState(
            {
                shouldRefreshSession: true,
            },
            () => {
                this.setState({
                    shouldRefreshSession: false,
                });
            },
        );
    };

    getProviderCompanyService = props => {
        const serviceId = props.consultService && props.consultService._id;
        if (props.providers && props.services && props.companies) {
            return props.providers.map(provider => {
                return props.services.map(service => {
                    if (service._id === serviceId) {
                        return props.companies.map(company => {
                            if (company._id === service.company) {
                                if (provider.uid === service.provider) {
                                    this.setState({
                                        provider,
                                        service,
                                        company,
                                    });
                                }
                            }
                        });
                    }
                });
            });
        } else {
            return null;
        }
    };

    handleSkipConfirmEndCallDialog = () => {
        this.props.history.push('/');
        this.props.updateLocation('/');
    };

    render() {
        // console.log('otherVideoUser', this.props.otherVideoUser)
        // console.log('props consultation', this.props)
        // console.log('state consultation', this.state)
        // console.log('Consultations-sessionData', this.props.sessionData && this.props.sessionData.token )
        const { provider, service, company } = this.state;
        const sessionData = this.props.sessionData;
        // console.log('Consultations-consultService', this.props.consultService && this.props.consultService._id )
        return [
            <div className="consultationsContainer" style={styles.container}>
                {this.props.userData && (
                    <div
                        className="componentGroup"
                        style={{
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'center',
                        }}
                    >
                        <LoginStartConsult
                            modal={false}
                            open={this.state.loginDialogOpen}
                            startConsult={this.state.joinSession}
                            handleClose={this.handleCloseLoginDialog}
                        />
                        {/* THIS SHOULD ONLY BE SHOWN IF EVERYTHING ELSE IS LOADED AS THIS ALWAYS APPEARS ON LOAD WHICH IS JARRING, ALSO IT DIDNT WORK */}
                        {/* { (!(sessionData && sessionData.token) || !(sessionData && sessionData.id) || !(sessionData && sessionData.apiKey)) && 
                            <FlexColumn center style={{ height:'100vh', justifyContent: 'center' }}>
                                <H2>Something went wrong with your connection</H2>
                                <Button onClick={this.handleRefreshSessionData}>Retry Call</Button>
                            </FlexColumn>
                        } */}
                        {sessionData && sessionData.token && sessionData.id && sessionData.apiKey && (
                            <ScreenDimensionProvider
                                render={(width, height) => (
                                    <VideoUI
                                        showLoginStart={this.handleOpenLoginDialog}
                                        userData={this.props.userData}
                                        sessionData={sessionData}
                                        isConfirmEndCallDialogOpen={
                                            this.props.isConfirmEndCallDialogOpen
                                        }
                                        otherUser={this.props.otherVideoUser}
                                        consultService={this.props.consultService}
                                        provider={provider}
                                        service={service}
                                        company={company}
                                        screenWidth={width}
                                        cameraToggle={this.cameraToggle}
                                        facingMode={this.state.facingMode}
                                        shouldRefreshSession={this.state.shouldRefreshSession}
                                        // REMOVE BELLOW PROPS WHEN ADDING CONSUMER SERVICE RATINGS
                                        handleSkipConfirmEndCallDialog={
                                            this.handleSkipConfirmEndCallDialog
                                        }
                                    />
                                )}
                            />
                        )}
                    </div>
                )}
            </div>,
        ];
    }
}

const mapStateToProps = ({
    provider,
    service,
    company,
    auth,
    video,
    client,
    chat,
    notification,
}) => {
    // console.log('Consultations-MSTP-company', company)
    // console.log('Consultations-MSTP-provider', provider)
    // console.log('Consultations-MSTP-service', service)
    // console.log('Consultations-MSTP-chat', chat)
    const { messages: messagesRedux, messageThread: channel } = chat;
    return {
        unreadContentCount: notification.unreadCount && notification.unreadCount,
        messagesRedux,
        channel,
        userData: client.clientData,
        codeIsVerified: video.isVerified,
        sessionData: video.session,
        token: video.token,
        userId: auth.authData ? auth.authData.id : null,
        isConfirmEndCallDialogOpen: video.isEndCallDialogOpen,
        otherVideoUser: video.otherUser,
        consultService: video.service,
        providers: provider.providers,
        services: service.services,
        companies: company.providerCompanies,
    };
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: 1,
    },
};

export default withRouter(
    preloadScript(
        connect(
            mapStateToProps,
            actions,
        )(Consultations),
    ),
);



// WEBPACK FOOTER //
// ./src/js/containers/Consultations.jsx